import { Stack } from 'expo-router';
import React, { useEffect } from 'react';
import { getAnonymousId } from 'services/analytics/segment/segment';
import { updateStatsigUser } from 'services/statsig/statsigManager';
import ScreenAnalytics from 'shared/components/ScreenAnalytics/ScreenAnalytics';
import { useAuth } from 'shared/providers/auth';
import theme from 'shared/styles/theme';
import { logBreadcrumb, logError } from 'shared/utils/sentry/sentry';

function PublicLayout() {
  const { isLoggedIn } = useAuth();

  // Sync Segment anonymousId with Statsig for unauthenticated users
  useEffect(() => {
    const syncAnonymousIdentity = async () => {
      if (isLoggedIn) {
        return;
      }

      try {
        const anonymousId = await getAnonymousId();
        if (anonymousId) {
          logBreadcrumb({
            level: 'info',
            message: 'Syncing anonymous identity to Statsig',
            data: { anonymousId },
          });
          await updateStatsigUser(anonymousId, anonymousId);
        }
      } catch (_error) {
        logError('Failed to sync anonymous identity to Statsig');
      }
    };

    void syncAnonymousIdentity();
  }, [isLoggedIn]);

  return (
    <>
      <ScreenAnalytics />
      <Stack
        screenOptions={{
          contentStyle: {
            backgroundColor: theme.color.background.primary,
          },
          headerShown: false,
        }}
      />
    </>
  );
}

export default PublicLayout;
